module.exports = __webpack_public_path__ + "arrow-down-white-91cb841fe5e72e802c9444383985ced3.svg";


//////////////////
// WEBPACK FOOTER
// ./Resources/public/static-src/images/icons/arrow-down-white.svg
// module id = 49
// module chunks = 0